// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__2CHJZ","info":"Note_info__3cHwp","note":"Note_note__3zFdF","actions":"Note_actions__LHkom"};